export const SET_ITINERARIES = 'SET_ITINERARIES';
export const SET_ITINERARIES_SUCCESS = 'SET_ITINERARIES_SUCCESS';
export const SET_OPTIONALINFO = 'SET_OPTIONALINFO';
export const SET_OPTIONALINFO_SUCCESS = 'SET_OPTIONALINFO_SUCCESS';
export const SET_NOTICEINFO = 'SET_NOTICEINFO';
export const SET_NOTICEINFO_SUCCESS = 'SET_NOTICEINFO_SUCCESS';
// export const TOGGLE_LIGHT_BOX = 'TOGGLE_LIGHT_BOX';
// export const CHANGE_SITE_INFO = 'CHANGE_SITE_INFO';
export const SET_STATIONINFO = 'SET_STATIONINFO';
export const SET_STATIONINFO_SUCCESS = 'SET_STATIONINFO_SUCCESS';
// export const SET_POI = 'SET_POI';
// export const SET_POI_SUCCESS = 'SET_POI_SUCCESS';
